import { GridBaseDataProvider } from '../../../../../../../../grid/GridBaseDataProvider';
import { GetRowsRequest, SetFiltersRequest } from '../../../../../../../../grid/types/common';
import { ConsoleRequest, DataProviderType } from '../../../../../../../../utils/request';
import { ProductGridItem, ProductRecord, ProductsColumnIndexes, ProductsColumnKeys } from '../types';
import { GridHelper } from '../../gridHelper';

export class ProductsGridDataProvider extends GridBaseDataProvider<ProductsColumnIndexes, ProductsColumnKeys> {
  public patchId: string;
  public productsCount: number;
  private productGridItems: Array<ProductGridItem> = [];
  private columnKeys = [ProductsColumnKeys.PRODUCT_NAME, ProductsColumnKeys.VENDOR_NAME];

  constructor(public dependencies: any) {
    super();
  }

  async getRows(request: GetRowsRequest<ProductsColumnIndexes, ProductsColumnKeys>): Promise<any> {
    if (this.productGridItems.length) {
      return GridHelper.applyFiltersOnGridItems(request, this.productGridItems, this.columnKeys);
    }

    const response = await this.readRecords(request);
    this.productGridItems = response.records.map(patch => this.transformPatchRecordToGridItem(patch));

    return { rawEvents: this.productGridItems };
  }

  private transformPatchRecordToGridItem(record: ProductRecord): ProductGridItem {
    return {
      [ProductsColumnKeys.PRODUCT_NAME]: record.name,
      [ProductsColumnKeys.VENDOR_NAME]: record.vendor.name,
    };
  }

  private async readRecords(request: GetRowsRequest<ProductsColumnIndexes, ProductsColumnKeys>): Promise<any> {
    let response;

    const payload = ConsoleRequest.mapGridRequestToPayload(request, this.dependencies.getTimezone());
    // this grid is designed to function without pagination, however there are scenarios when we need to load more items
    // than the default limit (20), so we need to overwrite the request parameter
    payload.limit = this.productsCount;
    payload.patchId = this.patchId;

    response = await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      payload,
      endpoint: 'ProductsCatalog',
      method: 'getProductsForPatch',
    });

    return response;
  }

  async setFilters(request: SetFiltersRequest<ProductsColumnKeys>): Promise<{} | undefined> {
    return {};
  }
}
